(function () {

    /**
     * Instantiate a video player class for quick access to play an html5 video
     * @ param {String} src - path to video
     * @ param {String} div - dom container to place the video in
     * @ param {Object} options - options for the video (id: String) (autoPlay: Bool)
     * @ param {Function} callback - function to call when the video's oncanplay Event is fired
     */
    function VideoPlayer(src, div, options, callback) {
        // Create the video and set props
        this.video = document.createElement("video");
        this.video.id = options.id === undefined ? "video" : options.id;
        this.video.src = src;
        var autoPlay = options.autoPlay === undefined ? false : options.autoPlay; // Default to false

        this.container = document.getElementById(div);
        this.container.appendChild(this.video);
        this.isVisible = false;
        // Set attributes for iOS so it doesn't play in fullscreen
        this.video.setAttribute("playsinline", "true");
        this.video.setAttribute("webkit-playsinline", "true");
        this.video.setAttribute("autoPlay", autoPlay.toString());
        if (!autoPlay) {
            this.video.pause();
        }
        // On error handle
        this.video.error = function (error) {
            console.log(error);
        };
        // Callback
        if (callback) {
            this.video.oncanplay = function () {
                callback();
            };
        }
        this.checkisMuted();
    }

    var p = VideoPlayer.prototype;

    /** Fade in the video and play */
    p.play = function(callback){
        this.endCallback = callback;
        this.video.play();
        this.setVideoEvents();
        this.isVisible = true;
    };

    p.checkisMuted = function()
    {
        if(!app.sound._contexts.sfx.muted)
        {
            this.video.volume = 1;
        } else if(app.sound._contexts.sfx.muted){
            this.video.volume = 0;
        }
    };

    p.muteVideoSound = function()
    {

        if(app.sound._contexts.sfx.muted)
        {
            this.video.volume = 1;
        } else if(!app.sound._contexts.sfx.muted){
            this.video.volume = 0;
        }
    };
    /** Pause the video */
    p.pause = function(remove){
		this.video.pause();
		if ( remove ) {
			this.removeVideo();
		}
    };

    /** Set the ended listener to fade out the video when video complete */
    p.setVideoEvents = function(){
        this.video.addEventListener('ended', this.fadeOutVideo.bind(this));
        this.video.addEventListener('webkitendfullscreen', this.fadeOutVideo.bind(this));
    };

    /** Hide the video using CSS keyframes */
    p.fadeOutVideo = function(){
        if(this.endCallback){
            var cb = this.endCallback;
            this.endCallback = null;
            cb();
            this.isVisible = false;
		}
		this.removeVideo();
	};

	p.removeVideo = function() {
		this.isVisible = false;

		var me = this;
		setTimeout(function() {
			me.video.parentNode.removeChild(me.video);
		}, 2000);
	};

    cm.VideoPlayer = VideoPlayer;

})();